import { ReportApiResponse } from '../types';

export async function fetchReportData(
  startDate: string,
  endDate: string
): Promise<ReportApiResponse> {
  const params = new URLSearchParams({
    startDate,
    endDate,
  });

  const res = await fetch(`/api/report?${params.toString()}`);
  const data = await res.json();

  if (!res.ok || !data.success) {
    throw new Error(data.error || `HTTP error ${res.status}: Failed to fetch report`);
  }

  return data as ReportApiResponse;
}
